import { all, fork } from 'redux-saga/effects'
import trackingSagas from './tracking.sagas'
import retailerDataLayer from './retailerDataLayer.sagas'
import splunkSagas from './splunk.sagas'
import googleAnalyticsSagas from './google.analytics.sagas'
import googleAdWordsSagas from './google.adwords.sagas'
import fbSagas from './fb.sagas'
import streamfullySagas from './streamfully.sagas'
import gclidSagas from './gclid.sagas'

const rootSaga = function* rootSaga() {
  yield all([
    fork(trackingSagas),
    fork(retailerDataLayer),
    fork(splunkSagas),
    fork(googleAnalyticsSagas),
    fork(googleAdWordsSagas),
    fork(fbSagas),
    fork(streamfullySagas),
    fork(gclidSagas),
  ])
}

export default rootSaga
